import React from "react";
import { Form } from "react-bootstrap";
import { useArsTable } from "./ArsTableContextProvider";
import { ARST_SET_SIDEBAR_FILTER } from "./interface";

/**
 * ArsTableSidebarFilter provides a text input that filters sidebar items
 * by matching against the currently visible items' names or descriptions.
 *
 * @returns Filter input element, or null when there is no table context
 */
export const ArsTableSidebarFilter = (): React.ReactNode => {
  const { state, dispatch } = useArsTable();

  return !state ? null : (
    <Form.Control
      size="sm"
      type="text"
      aria-label="Filter sidebar items"
      placeholder="Filter items…"
      value={state.settings.currentSidebar.filter ?? ""}
      disabled={state.settings.disabled}
      onChange={(event) => {
        dispatch({
          operation: ARST_SET_SIDEBAR_FILTER,
          filter: event.currentTarget.value,
        });
      }}
    />
  );
};

ArsTableSidebarFilter.displayName = "ArsTableSidebarFilter";
